<template>
    <div class="message_wrap" v-loading="loading">
        <div class="messgae_tab">
            <ul>
                <li
                    v-for="item in tabList"
                    :key="item.state"
                    :class="{ active: item.state == tabActive }"
                    @click="handleClickTab(item)"
                >
                    <i :class="['iconfont', item.state == tabActive ? item.activeIcon : item.icon]"></i>
                    <span>{{ item.name }}</span>
                </li>
            </ul>
        </div>
        <div class="message_list" v-if="tabActive == 'setting'">
            <p class="message_list_title">消息管理</p>
            <div class="message_list_content">
                <ul>
                    <li
                        v-for="item in categoryList"
                        :key="item.type"
                        class="message_list_item"
                        :class="{
                            active: item.id == category_id,
                        }"
                        @click="handleChangeCategory(item)"
                    >
                        <div class="message_list_item_icon">
                            <img :src="item.icon_url" alt="" />
                        </div>
                        <p class="message_list_item_content">{{ item.name }}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="message_right">
            <template v-if="tabActive == 'setting'">
                <p class="message_right_title">关闭后，将不再收到此类消息提醒，可在消息免打扰中查看</p>
                <ul>
                    <li v-for="item in templateList" :key="item.id">
                        <span>{{ item.template_name }}</span>
                        <el-switch
                            v-model="item.is_closed"
                            active-color="#2990FF"
                            inactive-color="#999999"
                            :active-value="false"
                            :inactive-value="true"
                            :width="44"
                            :disabled="item.can_disturb === false ? true : false"
                            @change="handleSwitchChange(item)"
                        >
                        </el-switch>
                    </li>
                </ul>
            </template>
            <template v-else>
                <div class="message_right_content2">
                    <ul>
                        <li>
                            <div>
                                <p class="title">设置消息免打扰时段</p>
                                <p>关闭后，消息提醒为实时通知，开启后，在免打扰时间段内，微信通知不再提醒</p>
                            </div>
                            <el-switch
                                size="small"
                                v-model="notDisturbForm.enabled"
                                active-color="#2990FF"
                                inactive-color="#999999"
                                :width="44"
                                @change="handleChangeTime"
                            >
                            </el-switch>
                        </li>
                    </ul>
                    <div class="time_wrap" v-show="notDisturbForm.enabled">
                        <span>每天</span>
                        <el-time-picker
                            @change="handleChangeTime"
                            size="small"
                            v-model="notDisturbForm.start_time"
                            format="HH:mm"
                            value-format="HH:mm"
                            placeholder="请选择"
                        >
                        </el-time-picker>
                        <span>至</span>
                        <el-select
                            @change="handleChangeTime"
                            size="small"
                            v-model="notDisturbForm.end_type"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in endDateTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-time-picker
                            @change="handleChangeTime"
                            size="small"
                            v-model="notDisturbForm.end_time"
                            format="HH:mm"
                            value-format="HH:mm"
                            placeholder="请选择"
                        >
                        </el-time-picker>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { MessageCategoryList, MessageTemplateList, MessageSettingSwitch, MessageSettingDistrubPeriod ,GetDistrubPeriod} from "@/api";
export default {
    name: "MessageAdminManagement",
    data() {
        return {
            loading: false,
            tabActive: "setting",
            tabList: [
                {
                    state: "setting",
                    name: "消息设置",
                    icon: "icon-xiaoxishezhi",
                    activeIcon: "icon-xiaoxishezhi-xuanzhong",
                },
                {
                    state: "resolveSetting",
                    name: "消息接收设置",
                    icon: "icon-xiaoxijieshoushezhi",
                    activeIcon: "icon-xiaoxijieshoushezhi-xuanzhong",
                },
            ],
            categoryList: [],
            category_id: "",
            templateList: [],
            notDisturbForm: {
                enabled: false,
                start_time: "23:00",
                end_type: 2,
                end_time: "08:00",
            },
            endDateTypeList: [
                { label: "当日", value: 1 },
                { label: "次日", value: 2 },
            ]
        };
    },
    created() {
        this.getMessageCategoryList();
    },
    methods: {
        handleClickTab({ state }) {
            this.tabActive = state;
            if (this.tabActive == "setting") {
                this.getMessageCategoryList();
            } else {
                this.getDistrubPeriod()
            }
        },
        // 获取消息分类列表
        getMessageCategoryList() {
            this.loading = true
            MessageCategoryList().then((res) => {
                if (res.code === 200) {
                    this.categoryList = res.data || [];
                    if (this.categoryList.length) {
                        this.category_id = this.categoryList[0].id;
                        this.getMessageTemplateList();
                    } else {
                        this.loading = false
                    }
                } else {
                    this.loading = false
                }
            }).catch(()=> {
                this.loading = false
            })
        },
        // 分类切换
        handleChangeCategory(item) {
            this.category_id = item.id;
            this.$nextTick(() => {
                this.getMessageTemplateList();
            });
        },
        // 获取分类下的模版
        getMessageTemplateList() {
            MessageTemplateList({ category_id: this.category_id }).then((res) => {
                if (res.code === 200) {
                    // 数据结构
                    // can_disturb: 是否可以设置免打扰 
                    // is_closed: 模版可以设置免打扰， 并且用户设置关闭了，就返回true为关闭，否则未开启。如果可以设置，就可以走开启免打扰
                    this.templateList = res.data || [];
                }
                this.loading= false
            }).catch(()=> {
                this.loading = false
            })
        },
        // 模版开启关闭
        handleSwitchChange(item) {
            const params = {
                template_id: item.template_id,
                status: item.is_closed, //是否开启免打扰 开启true 关闭false
            }
            MessageSettingSwitch(params).then(res=> {
                if(res.code === 200) {
                    this.$message.success('设置成功');
                }
            })
        },
        // 获取免打扰时间段
        getDistrubPeriod() {
            this.loading = true
            GetDistrubPeriod().then(res=> {
                if(res.code == 200) {
                    this.notDisturbForm.enabled = res.data.enabled
                    if(res.data && res.data.start_time) {
                        this.notDisturbForm.start_time = res.data.start_time 
                    }
                    if(res.data && res.data.end_type) {
                        this.notDisturbForm.end_type = res.data.end_type
                    }
                    if(res.data && res.data.end_time) {
                        this.notDisturbForm.end_time = res.data.end_time
                    }

                }
                this.loading = false
            }).catch(()=> {
                this.loading = false
            })
        },
        // 免打扰时间段设置
        handleChangeTime() {
            let params = {}
            if (this.notDisturbForm.enabled && this.notDisturbForm.end_type == 1) {
                if (this.notDisturbForm.end_time < this.notDisturbForm.start_time) {
                    this.$message.error("结束时间不能小于开始时间");
                    return false;
                }
            }
            if (this.notDisturbForm.enabled && (!this.notDisturbForm.start_time || !this.notDisturbForm.end_time)) {
                return false;
            }
            if(this.notDisturbForm.enabled) {
                params = {
                enabled: this.notDisturbForm.enabled,
                start_time: this.notDisturbForm.start_time ? this.notDisturbForm.start_time : "",
                end_type: this.notDisturbForm.end_type,
                end_time: this.notDisturbForm.end_time ? this.notDisturbForm.end_time : "",
                }
            }else {
                params = {
                    enabled: this.notDisturbForm.enabled,
                    start_time: "",
                    end_type: "",
                    end_time: ""
                }
            }
            MessageSettingDistrubPeriod(params).then((res) => {
                if (res.code === 200) {
                    this.$message.success("设置成功");
                }
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.message_wrap {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    display: flex;

    .messgae_tab {
        width: 152px;
        background-color: #ffffff;
        flex-shrink: 0;

        ul {
            padding: 16px 8px;

            li {
                width: 100%;
                height: 30px;
                padding: 0 8px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                color: rgba(102, 102, 102, 1);
                border-radius: 4px;
                margin-bottom: 4px;
                display: flex;
                align-items: center;
                gap: 4px;
                cursor: pointer;

                .iconfont {
                    font-size: 14px;
                }

                span {
                    line-height: 22px;
                }

                span:last-child {
                    flex: 1;
                }

                &.disabled {
                    color: rgba(153, 153, 153, 1);
                }

                &:hover {
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }

                &.active,
                &:active {
                    background-color: rgba(41, 144, 255, 0.1);
                    color: rgba(41, 144, 255, 1);
                    font-weight: 700;
                }
            }
        }
    }

    .message_list {
        width: 276px;
        border-left: 1px solid rgba(0, 0, 0, 0.04);
        background-color: #ffffff;
        flex-shrink: 0;

        .message_list_title {
            padding: 16px;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(34, 34, 34, 1);
        }

        .message_list_content {
            width: 100%;
            height: calc(100% - 56px);
            overflow: auto;

            ul {
                padding: 0 8px;
            }

            .message_list_item {
                padding: 8px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 4px;
                cursor: pointer;

                .message_list_item_icon {
                    width: 42px;
                    height: 42px;
                    position: relative;
                    flex-shrink: 0;

                    img {
                        width: 42px;
                        height: 42px;
                    }

                    .count {
                        position: absolute;
                        top: -1px;
                        right: -1px;
                        padding: 0 4px;
                        min-width: 18px;
                        height: 18px;
                        line-height: 16px;
                        text-align: center;
                        border: 1px solid #ffffff;
                        font-size: 10px;
                        font-weight: 500;
                        color: #ffffff;
                        border-radius: 10px;
                        background-color: rgba(228, 65, 68, 1);

                        &.count_notDisturb {
                            background-color: rgba(191, 191, 191, 1);
                        }
                    }
                }

                .message_list_item_content {
                    flex: 1;
                    overflow: hidden;
                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
                &:hover {
                    background-color: rgba(0, 0, 0, 0.04);
                }
                &.active,
                &:active {
                    background-color: rgba(41, 144, 255, 0.1);
                }
            }
        }
    }
    .message_right {
        border-left: 1px solid rgba(0, 0, 0, 0.04);
        flex: 1;
        background-color: #ffffff;
        padding: 16px;
        overflow: hidden;
        .message_right_title {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 17.38px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 16px;
        }
        ul {
            li {
                height: 54px;
                border-radius: 6px;

                border: 1px solid rgba(153, 153, 153, 0.1);
                padding: 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 8px;
                & > span {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
                ::v-deep {
                    .el-switch.is-disabled {
                        .el-switch__core {
                            color: rgba(182, 217, 255, 1);
                            border-color: rgba(182, 217, 255, 1) !important;
                            background-color: rgba(182, 217, 255, 1) !important;
                        }
                    }
                }
            }
        }
        .message_right_content2 {
            ul {
                li {
                    height: 72px;
                    padding: 12px 16px;
                    p {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(153, 153, 153, 1);
                    }
                    .title {
                        font-size: 16px;
                        font-weight: 700;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(51, 51, 51, 1);
                        margin-bottom: 2px;
                    }
                }
            }
            .time_wrap {
                display: flex;
                align-items: center;
                gap: 8px;
                & > span {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
                .el-input,
                .el-select {
                    width: 262px;
                }
            }
        }
    }
    ::v-deep {
        .el-switch {
            .el-switch__core {
                width: 44px !important;
                height: 22px !important;
                line-height: 22px !important;
                &::after {
                    width: 18px;
                    height: 18px;
                }
            }
        }
        .el-switch.is-checked .el-switch__core::after {
            margin-left: -19px !important;
        }
    }
}
</style>
